module.exports = __webpack_public_path__ + "static/media/correct-face-match.670b451f.gif";